// Login New Studies Routes
import { lazy } from 'react'
import { createRoute } from '@/helpers/createRoute'

const LoginNewStudies = lazy(() => import('@/pages/LoginNewStudies'))
const NewStudyLogin = lazy(() => import('@/modules/login-new-studies/NewStudyLogin'))
//const NewStudyLogin = lazy(() => import('@/modules/login-new-studies/NewStudyLogin3'))
const EditLogReportLNS = lazy(() => import('@/modules/login-new-studies/EditLogReport'))
const EditStudyLogin = lazy(() => import('@/modules/login-new-studies/EditStudyLogin'))
const AuthorizeStudyLogin = lazy(() => import('@/modules/login-new-studies/AuthorizeStudyLogin'))

// const InProgress = lazy(() => import('@/pages/InProgress'))

export const loginNewStudiesRoutes = {
  ...createRoute('loginNewStudies', <LoginNewStudies />),
  children: [
    createRoute('newStudyLogin', <NewStudyLogin />),
    createRoute('editStudyLogin', <EditStudyLogin />),
    createRoute('authorize', <AuthorizeStudyLogin />),
    createRoute('editLogReport', <EditLogReportLNS />)
  ]
}
